var generic = window.generic || {};
var site = window.site || {};

(function ($) {
  site.waitlist = {
    templateContainer: $(),

    initWaitlistSignup: function () {
      var $emailContainerNodes = this.templateContainer;

      if ($emailContainerNodes.length === 0) {
        return null;
      }

      $emailContainerNodes.each(function () {
        var $waitlistContainer = $(this);
        var $waitlistForm = $('.js-waitlist-signup-form', $waitlistContainer);
        var $waitlistSubmit = $('.js-waitlist-form-submit', $waitlistContainer);
        var $waitlistProgress = $('.js-waitlist-progress', $waitlistContainer);
        var $waitlistSuccess = $('.js-success', $waitlistContainer);
        var $waitlistError = $('.error', $waitlistContainer);
        var $waitlistInput = $('.js-waitlist-signup', $waitlistContainer);
        var $waitlistSubmissionOption = $('.js-redirect-or-text', $waitlistContainer);
        var $waitlistRedirectURL = $('.js-redirect', $waitlistContainer);
        var $waitlistSignupText = $('.js-waitlist-signup-text', $waitlistContainer);
        var $waitlistSignupFields = $('.js-waitlist-signup-fields', $waitlistContainer);
        var $emailOptStatus = $('.js-address-info-newsletter', $waitlistContainer);
        var $waitlistFirstName = $('.js-waitlist-firstname', $waitlistContainer);
        var $waitlistLastName = $('.js-waitlist-lastname', $waitlistContainer);
        var $waitlistEmail = $('.js-waitlist-email', $waitlistContainer);
        var $waitlistEmailPromotions = $('.js-email-promotions', $waitlistContainer);
        var $wailistCloseButton = $('.js-close-button', $waitlistContainer);
        var $nameInputsError;
        var $nameFieldsError;
        var $birthInputsError;
        var $birthFieldsError;
        var birthFieldsRegex;
        var nameFieldsRegex;
        var waitlistURL;
        var formSerial;
        var paramArr;
        var paramStr;
        var splitParam;
        var params;

        $wailistCloseButton.once().on('click', function () {
          $waitlistContainer.slideUp(600);

          return false;
        });
        // If the user is logged in, the fields are populated
        if (site && site.userInfoCookie) {
          if (site.userInfoCookie.getValue('signed_in') === '1') {
            $waitlistFirstName.val(site.userInfoCookie.getValue('first_name'));
            $waitlistLastName.val(site.userInfoCookie.getValue('last_name'));
            $waitlistEmail.val(site.userInfoCookie.getValue('email'));
            if (site.userInfoCookie.getValue('pc_email_optin') === '1') {
              $waitlistEmailPromotions.attr('checked', 'checked');
            }
          }
        }

        $waitlistForm
          .not('.js-email-form-processed')
          .addClass('js-email-form-processed')
          .once()
          .on('submit', function (submitEvt) {
            submitEvt.preventDefault();
            // Retrieve form data in querystring format
            formSerial = $waitlistForm.serialize();
            // Transform string into array of form elements
            paramArr = formSerial.split('&');
            paramStr = '';

            // Button disabled, instead of hiding, as requested
            $waitlistSubmit.prop('disabled', true);
            $waitlistProgress.removeClass('waitlist__progress--invisible');

            $waitlistInput.each(function () {
              var $waitlistInputField = $(this);
              const trimmedValue = $waitlistInputField.val().trim();

              if (trimmedValue) {
                $waitlistInputField.val(trimmedValue);
              }
            });

            paramArr.forEach(function (item) {
              splitParam = item.split('=');
              paramStr += '"' + splitParam[0] + '":"' + splitParam[1] + '",';
            });

            // Parse the string and create the literal object
            params = JSON.parse(
              '{' +
                paramStr
                  .substring(0, paramStr.length - 1)
                  .replace('undefined', '')
                  .replace('%40', '@') +
                '}'
            );

            // Send the data via a json rpc call
            generic.jsonrpc.fetch({
              method: 'rpc.form',
              params: [params],
              onSuccess: function () {
                // Redirect the current page to another
                waitlistURL = $waitlistRedirectURL.attr('href');
                if (
                  $waitlistSubmissionOption.val() === 'redirect' &&
                  waitlistURL &&
                  waitlistURL.length > 0
                ) {
                  if (/^\/.+$/.test(waitlistURL)) {
                    waitlistURL = waitlistURL.replace(/^(\s|\/)+/, '');
                  }
                  if (/^(?!http|\/).+$/.test(waitlistURL)) {
                    waitlistURL = Drupal.settings.basePath + waitlistURL;
                  }
                  window.location.href = waitlistURL;

                  return false;
                }
                // Show success messages within this template
                $waitlistProgress.addClass('hidden');
                $waitlistSuccess.removeClass('hidden');
                $waitlistError.addClass('hidden');
                $waitlistForm.addClass('hidden');
                $emailOptStatus.addClass('hidden');
                $waitlistSignupText.addClass('hidden');
                $waitlistSignupFields.addClass('hidden');
                $waitlistContainer.addClass('waitlist__email-success');
                $('html,body').animate(
                  {
                    scrollTop: 0
                  },
                  1000
                );
                // Tagging
                $(document).trigger('waitlist:success', [
                  $waitlistContainer.find('.js-waitlist-event-id')
                ]);
              },
              onFailure: function (jsonRpcResponse) {
                // Add the error messages below the header
                var errorObjectsArray = jsonRpcResponse.getMessages();

                $waitlistError.html('');
                $waitlistInput.removeClass('error');
                birthFieldsRegex = new RegExp('birth_\\w+', 'i');
                nameFieldsRegex = new RegExp('PC_EMAIL_ADDRESS|(?:FIRST|LAST)_NAME', 'i');

                errorObjectsArray.forEach(function (e) {
                  // For birthday input fields.
                  if (birthFieldsRegex.test(e.key)) {
                    const matches = e.key.match(birthFieldsRegex);
                    const str = matches[0];

                    // Always 1 match per field, so select first match
                    $birthInputsError = $(
                      "[id='form--profile_preferences--field--" + str.toUpperCase() + "']"
                    );
                    $birthFieldsError = $("[id*='" + str + "'][class='error error-block']");

                    $birthInputsError.addClass('error');
                    $birthFieldsError.addClass('error').text(e.text);
                  }
                  // For name, last_name, email input fields.
                  if (nameFieldsRegex.test(e.key)) {
                    const matches = e.key.match(nameFieldsRegex);
                    const str = matches[0];

                    // Always 1 match per field, so select first match
                    $nameInputsError = $(
                      "[id='waitlist_signup--field--" + str.toUpperCase() + "']"
                    );
                    $nameFieldsError = $("[id*='" + str + "'][class='error error-block']");

                    $nameInputsError.addClass('error');
                    $nameFieldsError.addClass('error').text(e.text);
                  }
                });
                $waitlistError.removeClass('hidden');
                $waitlistProgress.addClass('waitlist__progress--invisible');
                $waitlistSubmit.prop('disabled', false);
                $waitlistContainer.removeClass('waitlist__email-success');
                // Tagging
                $(document).trigger('waitlist:failure', [
                  $waitlistContainer.find('.js-waitlist-event-id')
                ]);
              }
            });
          });
      });
    }
  };

  Drupal.behaviors.waitlistSignupV1 = {
    attached: false,
    attach: function (context) {
      var $termsDetails = $('.js-waitlist-terms-details', context);
      var $termsArrow1 = $('.js-waitlist-terms-arrow-1', context);
      var $termsArrow2 = $('.js-waitlist-terms-arrow-2', context);
      var $termsTrigger = $('.js-waitlist-terms-trigger', context);
      var $waitlistDateField = $('.js-waitlist-date-of-birth', context);
      var maxYear = 18;
      var currentDate = new Date();
      var currentYear = currentDate.getFullYear();
      var validYear = currentYear - maxYear;
      var getOption;
      var getDateField;

      if (this.attached) {
        return;
      }
      this.attached = true;
      site.waitlist.templateContainer = $('.js-waitlist', context);
      site.waitlist.initWaitlistSignup();

      function populateSelect(target, min, max) {
        getDateField = document.getElementById(target);
        min = min || 0;
        max = max || min + 100;
        for (var i = min; i <= max; i++) {
          getOption = document.createElement('option');

          getOption.value = i;
          getOption.innerHTML = i;
          getDateField.appendChild(getOption);
        }
      }

      if ($waitlistDateField.length > 0) {
        populateSelect('form--profile_preferences--field--BIRTH_DAY', 1, 31);
        populateSelect('form--profile_preferences--field--BIRTH_MONTH', 1, 12);
        populateSelect('form--profile_preferences--field--BIRTH_YEAR', 1901, validYear);
      }

      $termsTrigger.once().on('click', function () {
        $termsDetails.toggle();
        $termsArrow1.toggle();
        $termsArrow2.toggle();
      });
    }
  };
})(jQuery);
